var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-rows" }, [
    _c(
      "div",
      { staticClass: "product-row" },
      _vm._l(_vm.productsAboveSlot, function(product) {
        return _c(
          "div",
          { key: product.id, staticClass: "card-column" },
          [
            _c("product-card", {
              attrs: {
                variants: product.variants,
                title: product.name,
                description:
                  product.introduction && product.introduction != ""
                    ? product.introduction
                    : product.description,
                media: product.media,
                "is-top": product.is_top,
                link: "/product/" + product.slug
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.productsAboveSlot.length > 0
      ? _c("div", { staticClass: "slot-wrapper" }, [_vm._t("default")], 2)
      : _vm._e(),
    _vm._v(" "),
    _vm.productsBelowSlot.length > 0
      ? _c(
          "div",
          { staticClass: "product-row" },
          _vm._l(_vm.productsBelowSlot, function(product) {
            return _c(
              "div",
              { key: product.id, staticClass: "card-column" },
              [
                _c("product-card", {
                  attrs: {
                    variants: product.variants,
                    title: product.name,
                    description:
                      product.introduction && product.introduction != ""
                        ? product.introduction
                        : product.description,
                    media: product.media,
                    "is-top": product.is_top,
                    link: "/product/" + product.slug
                  }
                })
              ],
              1
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }